// YOSHI-10464: the shell snippets of the quickstart.
//
// They are technical content and are the same in every language, which is why they live here and not
// in the translation catalogs. They run against the base url of the contract and read the credentials
// from shell variables, so nobody ends up with a client_secret written in their shell history.
//
// `jq` is used to read a field out of a response. It is not required by the API: it only keeps the
// examples to one line instead of a JSON parser written inline.

import { API_BASE_URL } from "./endpoints";

export const QUICKSTART_ENVIRONMENT_SNIPPET: string = `export BASE_URL="${API_BASE_URL}"
export CLIENT_ID="ypa_3f9c1d7a4b82e05f6c1a9d8e2b40f573"
export CLIENT_SECRET="ypas_8d2e4f6a1c03b957e8d1f2a4c6b093d7e5f81a2c4b60d9e3"`;

export const QUICKSTART_TOKEN_SNIPPET: string = `ACCESS_TOKEN=$(curl -s -X POST "$BASE_URL/v1/oauth/token" \\
  -H "Content-Type: application/json" \\
  -d "{\\"client_id\\": \\"$CLIENT_ID\\", \\"client_secret\\": \\"$CLIENT_SECRET\\"}" \\
  | jq -r .access_token)

export ACCESS_TOKEN`;

export const QUICKSTART_VENUES_SNIPPET: string = `curl -s "$BASE_URL/v1/venues" \\
  -H "Authorization: Bearer $ACCESS_TOKEN" | jq '.data[] | {uuid, name}'`;

export const QUICKSTART_EVENTS_SNIPPET: string = `curl -s "$BASE_URL/v1/events?limit=5" \\
  -H "Authorization: Bearer $ACCESS_TOKEN" | jq '.data[] | {uuid, name, starts_at, status}'`;

export const QUICKSTART_SALES_SNIPPET: string = `export EVENT_UUID="3a7f5e21-8c94-4b0d-9e15-6f2a8b3c4d5e"

curl -s "$BASE_URL/v1/sales?event=$EVENT_UUID&limit=10" \\
  -H "Authorization: Bearer $ACCESS_TOKEN" | jq '{total_rows, has_more, first: .data[0].code}'`;
